<template>
  <div class="dictionaries">
    <transition name="slide" mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'dicitionaries-view'
}
</script>

<style lang="scss" scoped>

</style>
